<template>
    <div class="upload-documents">

        <div class="upload-card">
            <div class="upload-card-top">
                <h3> Proof of Identity
                    <strong
                            :class="{
              'verify-info':true,
              'red':Number(ruleForm.identity_auth_status)===0||Number(ruleForm.identity_auth_status)===1||Number(ruleForm.identity_auth_status)===3,
              'orange':Number(ruleForm.identity_auth_status)===2,
              'green':Number(ruleForm.identity_auth_status)===4,
              }">
                        {{verify_info[Number(ruleForm.identity_auth_status)]}}
                    </strong></h3>
            </div>
            <div class="upload-card-view">
                <ul>
                    <li>• National ID Card</li>
                    <li>• Passport (photo page)</li>
                    <li>• Driving License (photo page/side)</li>
                </ul>
                <p style="margin-bottom:10px;"><span class="info" v-if="Number(ruleForm.identity_auth_status)!==4">Note: All documents submitted must be valid.</span>
                </p>

                <div class="upload-view clearfix">
                    <el-upload
                            class="avatar-uploader"
                            :action="upload_url"
                            :show-file-list="false"
                            :headers="headers"
                            :on-success="handleAvatarSuccess_one"
                            :before-upload="beforeAvatarUpload_one">
                        <template v-if="ruleForm.identity_upload_img&&~ruleForm.identity_upload_img.indexOf('pdf')">
                            <a class="pdf-icon" :href="ruleForm.identity_upload_img" target="_blank"></a>
                            <p class="pdf-text">pdf</p>
                        </template>
                        <img
                                v-else-if="ruleForm.identity_upload_img&&(~ruleForm.identity_upload_img.indexOf('jpeg')||~ruleForm.identity_upload_img.indexOf('gif')||~ruleForm.identity_upload_img.indexOf('jpg')||~ruleForm.identity_upload_img.indexOf('png'))"
                                :src="ruleForm.identity_upload_img"
                                class="avatar"
                        >
                        <div v-else>
                            <i class="el-icon-plus avatar-uploader-icon"></i>
                            <p>File</p>
                        </div>
                    </el-upload>
                    <strong class="tips"
                            v-if="Number(ruleForm.identity_auth_status)===0||Number(ruleForm.identity_auth_status)===1">No
                        files were selected</strong>
                </div>
                <div style="margin-top:10px;">
                    <span class="info">File format:jpg, gif, png, pdf.   Size:＜5M</span>
                    <el-button type="primary" class="box-btn" v-if="Number(ruleForm.identity_auth_status)!==4"
                               style="width: 221px;margin-left:140px" @click="upload_event('identity')">Upload
                    </el-button>
                    <strong
                            :class="{
              'verify-info':true,
              'red':Number(ruleForm.identity_auth_status)===0||Number(ruleForm.identity_auth_status)===1||Number(ruleForm.identity_auth_status)===3,
              'orange':Number(ruleForm.identity_auth_status)===2,
              'green':Number(ruleForm.identity_auth_status)===4,
              }"> {{verify_info[Number(ruleForm.identity_auth_status)]}}</strong>
                </div>
            </div>
        </div>

        <div class="upload-card">
            <div class="upload-card-top"><h3> Proof of Address
                <strong :class="{
            'verify-info':true,
              'red':Number(ruleForm.address_auth_status)===0||Number(ruleForm.address_auth_status)===1||Number(ruleForm.address_auth_status)===3,
              'orange':Number(ruleForm.address_auth_status)===2,
              'green':Number(ruleForm.address_auth_status)===4,
            }" style="">
                    {{verify_info[Number(ruleForm.address_auth_status)]}}
                </strong></h3></div>
            <div class="upload-card-view">
                <ul>
                    <li>• National ID card</li>
                    <li>• Driving license</li>
                    <li>• Hukou (Mainland China only)</li>
                    <li>• Residence permit</li>
                    <li>• no more than 3-month old utility bills, credit card statement, bank statement</li>
                </ul>
                <p style="margin-bottom:10px;"><span class="info" v-if="Number(ruleForm.address_auth_status)!==4">Note: Document already submitted for Proof of Identity may not be accepted again for Proof of Address.</span>
                </p>
                <div class="upload-view clearfix">
                    <el-upload
                            class="avatar-uploader"
                            :headers="headers"
                            :action="upload_url"
                            :show-file-list="false"
                            :on-success="handleAvatarSuccess_two"
                            :before-upload="beforeAvatarUpload_two">
                        <template v-if="ruleForm.address_upload_img&&~ruleForm.address_upload_img.indexOf('pdf')">
                            <a class="pdf-icon" :href="ruleForm.address_upload_img" target="_blank"></a>
                            <p class="pdf-text">pdf</p>
                        </template>
                        <img
                                v-else-if="ruleForm.address_upload_img&&(~ruleForm.address_upload_img.indexOf('jpeg')||~ruleForm.address_upload_img.indexOf('gif')||~ruleForm.address_upload_img.indexOf('jpg')||~ruleForm.address_upload_img.indexOf('png'))"
                                :src="ruleForm.address_upload_img"
                                class="avatar"
                        >
                        <div v-else>
                            <i class="el-icon-plus avatar-uploader-icon"></i>
                            <p>File</p>
                        </div>
                    </el-upload>
                    <strong class="tips"
                            v-if="Number(ruleForm.address_auth_status)===0||Number(ruleForm.address_auth_status)===1">No
                        files were selected</strong>
                </div>
                <div style="margin-top:10px;">
                    <span class="info">File format:jpg, gif, png, pdf.   Size:＜5M</span>
                    <el-button type="primary" v-if="Number(ruleForm.address_auth_status)!==4" class="box-btn"
                               style="width: 221px;margin-left:140px" @click="upload_event('address')">Upload
                    </el-button>
                    <strong :class="{
              'verify-info':true,
              'red':Number(ruleForm.address_auth_status)===0||Number(ruleForm.address_auth_status)===1||Number(ruleForm.address_auth_status)===3,
              'orange':Number(ruleForm.address_auth_status)===2,
              'green':Number(ruleForm.address_auth_status)===4,
              }" style=""> {{verify_info[Number(ruleForm.address_auth_status)]}}</strong>
                </div>
            </div>
        </div>

        <div class="upload-card">
            <div class="upload-card-top"><h3>Other supporting document（optional）
                <strong :class="{
            'verify-info':true,
            'red':Number(ruleForm.other_credential_status)===0||Number(ruleForm.other_credential_status)===1,
            'green':Number(ruleForm.other_credential_status)===2,
            }" style="">
                    {{verify_info2[Number(ruleForm.other_credential_status)]}}
                </strong></h3></div>
            <div class="upload-card-view">
                <div class="upload-view clearfix">
                    <el-upload
                            class="avatar-uploader"
                            :action="upload_url"
                            :headers="headers"
                            :show-file-list="false"
                            :on-success="handleAvatarSuccess_three"
                            :before-upload="beforeAvatarUpload_three">
                        <template v-if="ruleForm.other_credential_upload_img&&~ruleForm.other_credential_upload_img.indexOf('pdf')">
                            <a class="pdf-icon" :href="ruleForm.other_credential_upload_img" target="_blank"></a>
                            <p class="pdf-text">pdf</p>
                        </template>
                        <img
                                v-else-if="ruleForm.other_credential_upload_img&&(~ruleForm.other_credential_upload_img.indexOf('jpeg')||~ruleForm.other_credential_upload_img.indexOf('gif')||~ruleForm.other_credential_upload_img.indexOf('jpg')||~ruleForm.other_credential_upload_img.indexOf('png'))"
                                :src="ruleForm.other_credential_upload_img"
                                class="avatar"
                        >
                        <div v-else>
                            <i class="el-icon-plus avatar-uploader-icon"></i>
                            <p>File</p>
                        </div>
                    </el-upload>
                    <strong class="tips"
                            v-if="Number(ruleForm.other_credential_status)===0||Number(ruleForm.other_credential_status)===1">No
                        files were selected</strong>
                </div>
                <div style="margin-top:10px;">
                    <span class="info">File format:jpg, gif, png, pdf.   Size:＜5M</span>
                    <el-button type="primary" class="box-btn" v-if="Number(ruleForm.other_credential_status)!==2"
                               style="width: 221px;margin-left:14px" @click="upload_event('other')">Upload
                    </el-button>
                    <strong :class="{
              'verify-info':true,
              'red':Number(ruleForm.other_credential_status)===0||Number(ruleForm.other_credential_status)===1,
              'green':Number(ruleForm.other_credential_status)===2,
              }" style=""> {{verify_info2[Number(ruleForm.other_credential_status)]}}</strong>
                </div>
            </div>
        </div>

        <el-dialog :visible.sync="dialogpromptVisible" width="520px" :before-close="handleClose"
                   :close-on-click-modal="false">
            <div class="dialog-Prompt-Visible">
                <h2>Special Terms and Conditions for Professional Clients</h2>
                <h4>Leverage</h4>
                <p>Higher leverages will be available to Professional Clients in comparison to those available to Retail
                    Clients. However, by gaining access to higher leverages you risk magnifying your losses.</p>

                <h4>Negative Balance</h4>
                <p>Mandatory negative balance protection available to Retail Clients is not available to Professional
                    Clients. It will be your responsibility to keep the account balance positive.</p>

                <h4>Safety of Funds</h4>
                <p>The requirements under the FCA client money rules (CASS) are less for Professional Clients. However,
                    the Company does offer the option of client funds being segregated. Individual clients will remain
                    protected up to a limit of £85,000 by the Financial Service Compensation Scheme (FSCS). Under
                    certain circumstances Professional
                    Clients will not have the right to refer their complaints to the Financial Ombudsman
                    Service (FOS).</p>

                <h4>Communication</h4>
                <p>We will use more sophisticated language when promoting our products and we will not be required to
                    provide you with a standardised risk warning.</p>

                <h4>Confirmation:</h4>
                <div class="confirmation-checkbox">
                    <el-checkbox v-model="agree_one" label="I confirm I have read and agreed to the Special Terms"
                                 name="type"></el-checkbox>
                    <span style="padding-left:22px;display:block;margin-bottom:10px">and Conditions for Professional Clients. </span>
                    <el-checkbox v-model="agree_two" label="I confirm I have read and agreed to the"
                                 name="type"></el-checkbox>
                    <a style="padding-left:22px;text-decoration: underline;color: #286ed7;" target="_block"
                       :href="terms_url">Terms and Agreements ..</a>
                </div>
                <el-button @click="event_prompt" class="box-btn-default">Continue</el-button>
            </div>
        </el-dialog>

    </div>
</template>

<script>
  import * as server from '../action'

  export default {
    data () {
      return {
        upload_url:
          process.env.NODE_ENV === 'production'
            ? '/file/upload'
            : '/api/file/upload',
        ruleForm: {
          address_auth_remark: '',
          address_auth_status: '',
          address_upload_img: '',
          identity_auth_remark: '',
          identity_auth_status: '',
          identity_upload_img: '',
          other_credential_status: '',
          other_credential_upload_img: ''
        },
        headers: {
          'Access-Token': localStorage.uk_token
        },
        verify_info: [
          'Not verified',
          'Not verified',
          'Verifying',
          'Verification failed',
          'verified '
        ],
        verify_info2: ['', 'Not verified', 'verified '],
        file_type: [
          'image/jpeg',
          'image/jpg',
          'image/gif',
          'image/png',
          'application/pdf'
        ],
        dialogpromptVisible: true,
        agree_one: '',
        agree_two: '',
        terms_url: 'http://www.zfx.co.uk/support/terms-agreements'
      }
    },
    created () {
      var str = location.href
      console.log(str)
      if (str.search('stb') != -1) {
        this.terms_url = 'http://www2.stb.zfx.co.uk/support/terms-agreements'
      }
      if (str.search('beta') != -1) {
        this.terms_url = 'http://www2.beta.zfx.co.uk/support/terms-agreements'
      }
      this.certification_apply_index()
    },
    methods: {
      certification_apply_index () {
        server.certification_apply_index({ step: 6 }).then(res => {
          Object.keys(this.ruleForm).map((val, key) => {
            this.ruleForm[val] = res.setting[val]
          })
        })
      },
      handleAvatarSuccess_one (res, file) {
        this.ruleForm.identity_upload_img = res.data.url
      },
      beforeAvatarUpload_one (file) {
        const isJPG = this.file_type.indexOf(file.type) !== -1
        const isLt2M = file.size / 1024 / 1024 < 5

        if (!isJPG) {
          this.$message.error('File type not accepted！')
        }
        if (!isLt2M) {
          this.$message.error('File type not accepted！')
        }
        if (Number(this.ruleForm.identity_auth_status) === 4) {
          this.$message.error(
            ' The approved documents will not be re-uploaded for review！'
          )
          return false
        }
        return isJPG && isLt2M
      },
      handleAvatarSuccess_two (res, file) {
        this.ruleForm.address_upload_img = res.data.url
      },
      beforeAvatarUpload_two (file) {
        console.log('file.type', file.type)
        const isJPG = this.file_type.indexOf(file.type) !== -1
        const isLt2M = file.size / 1024 / 1024 < 5

        if (!isJPG) {
          this.$message.error('File type not accepted！')
        }
        if (!isLt2M) {
          this.$message.error('File type not accepted！')
        }

        if (Number(this.ruleForm.address_auth_status) === 4) {
          this.$message.error(
            ' The approved documents will not be re-uploaded for review！'
          )
          return false
        }

        return isJPG && isLt2M
      },
      handleAvatarSuccess_three (res, file) {
        this.ruleForm.other_credential_upload_img = res.data.url
      },
      beforeAvatarUpload_three (file) {
        const isJPG = this.file_type.indexOf(file.type) !== -1
        const isLt2M = file.size / 1024 / 1024 < 5

        if (!isJPG) {
          this.$message.error('File type not accepted！')
        }
        if (!isLt2M) {
          this.$message.error('File type not accepted！')
        }
        if (Number(this.ruleForm.other_credential_status) === 2) {
          this.$message.error(
            ' The approved documents will not be re-uploaded for review！'
          )
          return false
        }
        return isJPG && isLt2M
      },
      upload_event (val) {
        let params = {}
        if (val === 'identity') {
          if (
            this.ruleForm.identity_upload_img.length === 0 ||
            !this.ruleForm.identity_upload_img
          ) {
            this.$message.error(' Please add a file first！')
          }
          params = {
            identity_upload_img: this.ruleForm.identity_upload_img,
            step: 6
          }
        } else if (val === 'address') {
          if (
            this.ruleForm.address_upload_img.length === 0 ||
            !this.ruleForm.address_upload_img
          ) {
            this.$message.error(' Please add a file first！')
          }
          params = {
            address_upload_img: this.ruleForm.address_upload_img,
            step: 6
          }
        } else if (val === 'other') {
          if (
            this.ruleForm.other_credential_upload_img.length === 0 ||
            !this.ruleForm.other_credential_upload_img
          ) {
            this.$message.error(' Please add a file first！')
          }
          params = {
            other_credential_upload_img: this.ruleForm
              .other_credential_upload_img,
            step: 6
          }
        }
        server.certification_apply_save(params, true).then(res => {
          if (res.code === 200) {
            this.$alert('success', {
              dangerouslyUseHTMLString: true,
              confirmButtonText: 'OK'
            })
              .then(() => {
                this.certification_apply_index()
              })
              .catch(action => {})
          } else {
            this.$message({
              message: res.message,
              type: 'warning'
            })
          }
        })
      },
      event_prompt () {
        if (this.agree_one && this.agree_two) {
          this.dialogpromptVisible = false
        } else {
          this.$alert(
            'You must agree to our Special Terms and Conditions for Professional Clients and our Terms and Agreements.',
            {
              dangerouslyUseHTMLString: true,
              confirmButtonText: 'OK'
            }
          )
        }
      },
      handleClose (done) {
        this.$router.push({ name: 'memberIndex' })
        done()
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
    .upload-documents {
        .pdf-icon {
            width: 30px;
            height: 37px;
            display: block;
            background: url("../../../assets/img/model_icon_img/pdf.jpg");
            margin: 26px auto 0;
        }
        .pdf-text {
            width: 89px;
        }
        .upload-card {
            width: 792px;
            margin: 30px auto 0;
            .upload-card-top {
                margin-bottom: 30px;
                > h3 {
                    font-size: 20px;
                    line-height: 19px;
                    color: #333333;
                }
            }
            .upload-card-view {
                border: solid 1px #dcdcdc;
                padding: 30px;
                > ul {
                    > li {
                        font-size: 14px;
                        font-weight: normal;
                        font-stretch: normal;
                        line-height: 25px;
                        letter-spacing: 0px;
                        color: #666666;
                        margin-bottom: 10px;
                    }
                }
                .info {
                    font-size: 14px;
                    line-height: 25px;
                    color: #cccccc;
                }
            }

            .avatar-uploader {
                width: 90px;
                height: 90px;
                background-color: #fff3e8;
                border: solid 1px #0A95FF;
                text-align: center;
                color: #0A95FF;
            }
            .avatar-uploader .el-upload {
                border: 1px dashed #d9d9d9;
                border-radius: 6px;
                cursor: pointer;
                position: relative;
                overflow: hidden;
                p {
                    color: #0A95FF;
                    font-size: 14px;
                }
            }
            .avatar-uploader .el-upload:hover {
                border-color: #409eff;
            }
            .avatar-uploader-icon {
                font-size: 40px;
                color: #0A95FF;
                width: 90px;
                height: 60px;
                line-height: 80px;
                text-align: center;
            }
            .avatar {
                width: 90px;
                height: 90px;
                display: block;
            }
        }
        .upload-view {
            .avatar-uploader {
                float: left;
            }
            .tips {
                padding-top: 35px;
                padding-left: 109px;
                font-weight: normal;
                color: #0A95FF;
                display: block;
            }
        }
        .verify-info {
            margin-left: 15px;
            display: inline-block;
            font-weight: normal;
            &.orange {
                color: #0A95FF;
            }

            &.red {
                color: #e03d41;
            }

            &.green {
                color: #40a83a;
            }
        }
        .dialog-Prompt-Visible {
            padding: 0 45px 30px;
            h2 {
                font-size: 16px;
                line-height: 24px;
                letter-spacing: 0px;
                color: #333333;
                font-weight: bold;
                margin-bottom: 30px;
            }
            h4 {
                font-size: 14px;
                font-weight: bold;
                line-height: 24px;
                letter-spacing: 0px;
                color: #0A95FF;
            }
            p {
                font-size: 14px;
                line-height: 24px;
                letter-spacing: 0px;
                color: #333333;
                margin-bottom: 10px;
            }
            .confirmation-checkbox {
                .el-checkbox {
                    display: block;
                    margin-left: 0;
                    .el-checkbox__label {
                        display: inline;
                        white-space: normal;
                        color: #333333 !important;
                    }
                }
            }
            .box-btn-default {
                display: block;
                width: 253px;
                height: 42px;
                background: #0A95FF;
                border-radius: 4px;
                color: #fff;
                margin: 40px auto 0;
            }
        }
    }
</style>
